// extracted by mini-css-extract-plugin
export default {"mainCon":"Panel_mainCon__0rLwO","header":"Panel_header__iJ30K","heading":"Panel_heading__N62nM","dropdownIcon":"Panel_dropdownIcon__BdnsZ","children":"Panel_children__8lRKS"};